import { useUserRoles } from '@anytag/auth';
import { useCreatePackageMutation, CompanyAndRolePair, namedOperations } from '@anytag/graphql';
import { useQueryHelper, useUpdateDocumentTitle, useAllPackageCompanyOptions } from '@anytag/shared-hooks';
import { Header } from '@anytag/shared-molecules';
import { PackageForm, PackageFormValues } from '@anytag/shared-organisms';
import { FormAction } from '@anytag/shared-types';

export const AddPackage = () => {
  useUpdateDocumentTitle({
    title: 'appHeader.Add Package',
    appHeader: 'appHeader.Add Package',
    backInHistory: { fallback: '/package' }
  });
  const { isAdminStaff } = useUserRoles();
  const { t, enqueueSnackbar, navigate } = useQueryHelper();
  const { allPackageCompanies } = useAllPackageCompanyOptions({ skip: !isAdminStaff });
  const { callCreatePackage } = useCreatePackageMutation({ refetchQueries: [namedOperations.Query.AllPackages] });

  const handleSubmit: FormAction<PackageFormValues>['onSubmit'] = async ({ name, countryId, companies }) => {
    try {
      const companyAndRolePairs = isAdminStaff
        ? allPackageCompanies.reduce<CompanyAndRolePair[]>(
            (rs, cr) => (companies.includes(String(cr.id)) ? [...rs, { companyId: cr.companyId, role: cr.role }] : rs),
            []
          )
        : [];
      await callCreatePackage({ variables: { input: { name, countryId, companyAndRolePairs } } });

      enqueueSnackbar(t('package has been saved successfully'), { variant: 'success' });
      navigate({ to: '/package' });
    } catch (error) {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    }
  };

  return (
    <div>
      <Header />

      <PackageForm onSubmit={handleSubmit} />
    </div>
  );
};
